import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initial: 'G',
  name: 'Gabriel T.',
  role: 'Emprendedor digital',
  quote: 'Marketing PRO me ayudó a entender por qué mi contenido no estaba vendiendo. Yo pensaba que necesitaba publicar más, pero en realidad necesitaba comunicar mejor. Las plantillas y hooks me simplificaron todo.'
}, {
  initial: 'M',
  name: 'Martina R.',
  role: 'Creadora de contenido',
  quote: 'El tomo de Contenido Que Convierte fue un antes y después. Dejé de publicar por publicar y empecé a crear contenido con intención. Ahora mis publicaciones generan más consultas.'
}, {
  initial: 'D',
  name: 'Diego F.',
  role: 'Dueño de ecommerce',
  quote: 'Los prompts de IA son una locura. Antes perdía horas pensando ideas y ahora tengo anuncios, hooks y reels en minutos.'
}, {
  initial: 'L',
  name: 'Laura P.',
  role: 'Infoproductora',
  quote: 'Lo que más me sirvió fueron los swipe files de anuncios. Tenía ideas, pero no sabía cómo estructurarlas para vender. Ahora tengo modelos claros para adaptar.'
}, {
  initial: 'N',
  name: 'Natalia G.',
  role: 'Marca personal',
  quote: 'Desde que uso Marketing PRO, mis reels tienen más sentido. Ya no hago contenido solo para tener vistas, ahora sé cómo llevar a la gente hacia la compra.'
}];
export const Testimonials = () => {
  return <section className="py-12 md:py-24 bg-brand-card/50" data-id="element-168">
      <div className="container px-4 mx-auto max-w-7xl" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-16 text-center" data-id="element-170">
          <h2 className="text-3xl font-bold md:text-5xl font-serif" data-id="element-171">
            Lo que dicen los{' '}
            <span className="text-gradient-gold" data-id="element-172">emprendedores</span>
          </h2>
        </motion.div>

        <div className="grid gap-4 md:gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-173">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-6 md:p-8 border bg-brand-dark rounded-2xl border-white/5 ${index === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-174">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-175">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-176" />)}
              </div>
              <p className="mb-4 md:mb-6 text-sm md:text-base text-gray-300 italic" data-id="element-177">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 md:gap-4 mt-auto" data-id="element-178">
                <div className="flex items-center justify-center w-10 h-10 font-bold text-black rounded-full bg-brand-gold" data-id="element-179">
                  {testimonial.initial}
                </div>
                <div data-id="element-180">
                  <div className="font-bold text-white" data-id="element-181">{testimonial.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-182">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};